import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';

export default function CheckupDialog({ open, onOpenChange, pregnancy, onSave }) {
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    status: 'good',
    veterinarian: '',
    notes: ''
  });

  const handleSubmit = () => {
    if (!formData.veterinarian) {
      toast.error('Debe indicar el nombre del veterinario');
      return;
    }

    if (!formData.notes) {
      toast.error('Debe agregar observaciones del chequeo');
      return;
    }

    onSave(formData);
    onOpenChange(false);
    
    // Reset form
    setFormData({
      date: new Date().toISOString().split('T')[0],
      status: 'good',
      veterinarian: '',
      notes: ''
    });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle>Agregar Revisión de Embarazo</DialogTitle>
        </DialogHeader>

        <div className="space-y-4 py-4">
          {/* Fecha de Revisión */}
          <div className="space-y-2">
            <Label>Fecha de Revisión</Label>
            <Input
              type="date"
              value={formData.date}
              onChange={(e) => setFormData(prev => ({ ...prev, date: e.target.value }))}
              max={new Date().toISOString().split('T')[0]}
            />
          </div>

          {/* Estado del Embarazo */}
          <div className="space-y-2">
            <Label>Estado del Embarazo</Label>
            <Select 
              value={formData.status} 
              onValueChange={(value) => setFormData(prev => ({ ...prev, status: value }))}
            >
              <SelectTrigger>
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="good">Normal - Todo bien</SelectItem>
                <SelectItem value="concern">Preocupante - Requiere atención</SelectItem>
                <SelectItem value="critical">Crítico - Emergencia</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* Veterinario */}
          <div className="space-y-2">
            <Label>Veterinario</Label>
            <Input
              placeholder="Nombre del veterinario..."
              value={formData.veterinarian}
              onChange={(e) => setFormData(prev => ({ ...prev, veterinarian: e.target.value }))}
            />
          </div>

          {/* Observaciones */}
          <div className="space-y-2">
            <Label>Observaciones del Chequeo</Label>
            <Textarea
              placeholder="Describe los hallazgos de la revisión..."
              value={formData.notes}
              onChange={(e) => setFormData(prev => ({ ...prev, notes: e.target.value }))}
              rows={4}
            />
          </div>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancelar
          </Button>
          <Button onClick={handleSubmit} className="bg-rose-600 hover:bg-rose-700">
            Guardar Revisión
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
